import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-cart',
    templateUrl: '../svgs/Cart.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--cart'
    },
    standalone: false
})
export class TellerOnlineIconCart {
}
